import React from 'react'
import { useToggle } from 'react-use'
import { ViewDatasetDescription } from './ViewDatasetDescription'
import { EditDatasetDescription } from './EditDatasetDescription'

import Heading from '../../../../../../uiKit/texts/Heading'

type DescriptionInfoProps = {
  title?: string
  text?: string
}

export const DatasetInfo: React.FC<DescriptionInfoProps> = ({ title = '', text = '' }) => {
  const [editForm, toggleEditForm] = useToggle(false)

  const handleOpenEditForm = () => {
    toggleEditForm(true)
  }

  const handleCloseEditForm = () => {
    toggleEditForm(false)
  }

  return (
    <div>
      <Heading>{title}</Heading>

      {editForm ? (
        <EditDatasetDescription text={text} onClose={handleCloseEditForm} />
      ) : (
        <ViewDatasetDescription text={text} onOpenEdit={handleOpenEditForm} />
      )}
    </div>
  )
}
